import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ErrorDetails } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";

export class GetAllChatContentCommand extends IRequestCommand<IGetAllChatContentResponse, ErrorDetails, IGetAllChatContentCommandParameters> {
    override _commandType: CommandRequestType = CommandRequestType.GET;
    override _commandUrl = 'chats/find?role={role}&carrierId={carrierId}&driverId={driverId}&page=1&size=1000&column=id&sort=DESC';

    public override setParameters(parameters: IGetAllChatContentCommandParameters) {
        this._commandUrl = this._commandUrl.replace('{role}', parameters.role.toString());
        this._commandUrl = this._commandUrl.replace('{carrierId}', parameters.carrierId.toString());
        this._commandUrl = this._commandUrl.replace('{driverId}', parameters.driverId.toString());
    }
}

export interface IGetAllChatContentCommandParameters{
    role: string;
    carrierId: number;
    driverId: number;
}

export interface IGetAllChatContentResponse {
}